import axios from 'axios'
import { publicApi } from './http'

export function fetchIp () {
  return publicApi.get('/api/external/ip')
}

export function fetchLocationByAbstract (params = {}, config = {}) {
  return publicApi.get('/api/external/location', { ...config, params })
}

export function fetchLocationByDadata (params = {}) {
  return publicApi.get('/api/external/location', { params })
}

export async function fetchPublicIp () {
  const response = await axios.get('https://api.ipify.org', {
    params: { format: 'json' },
    timeout: 5000
  })
  return response?.data?.ip || null
}
